import { jsxs as t, jsx as s } from "react/jsx-runtime";
import { twJoin as m } from "tailwind-merge";
import p from "./store-image.mjs";
import { useDesignContext as d } from "../providers/use-design-provider.mjs";
const N = ({
  title: r,
  subTitle: o,
  thumbnail: e,
  imageType: a,
  headingLevel: c = "h2"
}) => {
  const { isDefaultTheme: l } = d(), x = c;
  return /* @__PURE__ */ t("div", { className: "flex gap-3", children: [
    /* @__PURE__ */ s(
      p,
      {
        className: "h-full shrink-0 rounded-xl",
        src: (e == null ? void 0 : e.thumbnail) ?? (e == null ? void 0 : e.path),
        imageType: a,
        alt: r
      }
    ),
    /* @__PURE__ */ t("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ s(
        x,
        {
          className: m(
            l ? "text-text-primary" : "text-THEME-primary",
            "text-xl font-semibold lg:text-2xl"
          ),
          children: r
        }
      ),
      /* @__PURE__ */ s("span", { className: "whitespace-pre-wrap font-medium", children: o })
    ] })
  ] });
};
export {
  N as default
};
